import GearIcon from "../../../../assets/Logo/CgearWhite.webp";
import './AuthLeftPanel.css';

export default function AuthLeftPanel() {
  return (
    <div className="left-panel" role="presentation" aria-hidden="true">
      <div className="left-card">
        <div className="left-card-inner">
          <div className="left-icon">
            <img
              src={GearIcon}
              alt="Gear Icon"
              style={{ width: "48px", height: "48px" }}
            />
          </div>
          <h2 className="left-title">Smarter CAD Starts Here</h2>
          <p className="left-sub">
            Unlock your design potential with tools tailored for engineers,
            architects, and creators.
          </p>
        </div>
      </div>
    </div>
  );
}
